export enum WorkloadRequirementSorting {
    Alphabet = 'Alphabet',
    BeginTime = 'BeginTime',
}
